import { filterOutrightsMarkets } from "../filterOutrightsMarkets";
import { filterOutrightSelections } from "../filterOutrightSelections";
import { observable } from "mobx";
export const prepareOutrightMarkets = (markets, events, outrightSelectionSorter) => {
    var _a;
    let sortMethod = outrightSelectionSorter.getSortStrategy((_a = markets[0]) === null || _a === void 0 ? void 0 : _a.sportId);
    return filterOutrightsMarkets(true, markets, events).map((market) => {
        market.selections = observable.array(filterOutrightSelections(market.selections).sort(sortMethod));
        return market;
    });
};
//# sourceMappingURL=prepareOutrightMarkets.js.map